import template from './agent-edit.html';
import controller from './agent-edit.controller';
import './agent-edit.scss';

const agentEditComponent = {
  bindings: {
    modalInstance: '<?',
    resolve: '<?'
  },
  template,
  controller,
  controllerAs: 'vm'
};

controller.$inject = ['$scope', '$rootScope', 'utils', 'agentService'];

export default agentEditComponent;
